import { render } from "./ParametrosConfig.vue?vue&type=template&id=07fecbf7&scoped=true"
import script from "./ParametrosConfig.vue?vue&type=script&lang=js"
export * from "./ParametrosConfig.vue?vue&type=script&lang=js"

import "./ParametrosConfig.vue?vue&type=style&index=0&id=07fecbf7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fecbf7"]])

export default __exports__